<div class="dialogContainer">
  <div class="header">
    <h2>Custom Scenario</h2>
  </div>
  <div class="content">
    <div class="inputRow">
      <span class="labelSpan">
        <label>Entity ID</label>
      </span>
      <input class="standardTextBox inputField" readonly [value]="fpaScenario.entityKey.entityId"/>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label>Rep</label>
      </span>
      <input class="standardTextBox inputField" readonly [value]="fpaEntity.salesRep"/>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label>Customer</label>
      </span>
      <input class="standardTextBox inputField" readonly [value]="fpaEntity.customer"/>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label>Lead Time</label>
      </span>
      <input class="standardTextBox inputField" readonly [value]="fpaEntity.leadTime"/>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label>Project Name</label>
      </span>
      <input class="standardTextBox inputField" readonly [value]="fpaEntity.projectName"/>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label>S &amp; H</label>
      </span>
      <input class="standardTextBox inputField" readonly [value]="fpaEntity.shippingCharge | currency:'USD'"/>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label># of Units</label>
      </span>
      <input class="standardTextBox inputField" readonly [value]="fpaEntity.numberOfUnits"/>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label>Total List</label>
      </span>
      <input class="standardTextBox inputField" readonly [value]="fpaEntity.totalList | currency:'USD'"/>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label>Sale Type</label>
      </span>
      <select class="inputField" [(ngModel)]="fpaScenario.saleType" (change)="clearInputs()">
        @for (channel of channels(); track channel) {
          <option [value]="channel.code">{{ channel.description }}</option>
        }
      </select>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label>Multiplier</label>
      </span>
      <input class="standardTextBox inputField" [readonly]="allowPoAmountOnly()" [(ngModel)]="fpaScenario.requestedMultiplier"/>
    </div>
    <div class="inputRow">
      <span class="labelSpan">
        <label>PO Amount</label>
      </span>
      <input class="standardTextBox inputField" [readonly]="allowMultiplierOnly()" [(ngModel)]="fpaScenario.poAmount"/>
    </div>
  </div>
  <div mat-dialog-actions>
    <span class="spacer"></span>
    <span>
      <button matButton="elevated" (click)="cancel()">Cancel</button>
      <button matButton="elevated" [disabled]="invalidEntry()" (click)="saveAndClose()">Save</button>
    </span>
  </div>
  @if (warningMessages && warningMessages.length > 0) {
    <div class="warning">
      @for (message of warningMessages; track message) {
        <div class="warningText">{{ message }}</div>
      }
    </div>
  }
  <div class="footer">
    <span>PO Amount and Total Sales Price do not include taxes</span>
  </div>
</div>

